import { HandoutShell, HandoutBrand, FeatureItem, HandoutFooter } from "./HandoutShell";
import {
  Camera, House, TreeStructure, Robot, Path, Coins,
  Certificate, Globe, ClockCounterClockwise, LockKey, DeviceMobile,
} from "@phosphor-icons/react";

const FEATURES = [
  { icon: Camera, title: "Snap a receipt → instant OCR", desc: "Point your camera; AI reads the vendor, VAT and total for you." },
  { icon: House, title: "Compliance score on the go", desc: "Your live score and key numbers, glanceable from anywhere.", color: "#00A86B" },
  { icon: TreeStructure, title: "Grant tracking in your pocket", desc: "Log grant spend the moment it happens — no more shoeboxes." },
  { icon: Robot, title: "Compliance AI advisor", desc: "Chat for Revenue.ie-aware answers wherever you are.", color: "#00A86B" },
  { icon: Path, title: "Mileage & ERR", desc: "HMRC 2026/27 mileage & subsistence rates built in." },
  { icon: Coins, title: "Tax reliefs", desc: "EII · SURE · R&D relief calculators on mobile.", color: "#00A86B" },
  { icon: Certificate, title: "Compliance certificates", desc: "Issue and open tamper-evident certificates from your phone." },
  { icon: Globe, title: "Trust Center link", desc: "Share your live, verifiable compliance page in one tap.", color: "#00A86B" },
  { icon: ClockCounterClockwise, title: "Recent activity & audit trail", desc: "Every action logged for a clean audit history." },
  { icon: LockKey, title: "Secure Google login + GDPR consent", desc: "Encrypted sign-in and consent recorded on device.", color: "#00A86B" },
];

export default function HandoutMobile() {
  return (
    <HandoutShell testid="handout-mobile">
      <HandoutBrand tag="Mobile App · iOS & Android" />

      <div className="mb-6">
        <div className="eyebrow mb-2">The Compliance Finance OS · in your pocket</div>
        <h1 className="font-display text-3xl leading-tight">
          Scan, track and stay <span style={{ color: "#FFB020" }}>audit-ready</span> — on the go.
        </h1>
        <p className="text-white/65 text-sm mt-3 max-w-2xl leading-relaxed">
          Capture receipts the second you spend, keep an eye on grants and compliance between meetings,
          and never let admin pile up again. Everything syncs with the PerCen360 web platform.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-x-8 gap-y-4">
        {FEATURES.map((f) => (
          <FeatureItem key={f.title} {...f} />
        ))}
      </div>

      <div className="glass rounded-xl px-5 py-4 mt-7 flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: "#FFB020" }}>
          <DeviceMobile size={20} weight="duotone" color="#050B0A" />
        </div>
        <div className="text-sm text-white/75">
          <span className="font-display">Installable app</span> — capture receipts in seconds and
          keep your compliance score with you, wherever the work happens.
        </div>
      </div>

      <HandoutFooter />
    </HandoutShell>
  );
}
